import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { withRouter, RouteComponentProps, Route } from 'react-router';
import { CampfireSwitch } from '../../../content-blocks/common/CampfireSwitch';
import { FormsList } from './FormsList/FormsList';
import { FormsMenubar } from './FormsMenubar';
import { FormBuilder } from './FormBuilder/FormBuilder';
import { FormResponsesScreen } from './FormResponses/FormResponsesScreen';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      height: 'calc(100vh - 57px)',
      overflowY: 'hidden',
      paddingLeft: (props: { isMobile: boolean }) => (props.isMobile ? '10px' : '20px'),
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

export const FormsScreenInner = withRouter(({ match }: RouteComponentProps) => {
  const { isMobile } = useCampfireTheme();
  const classes = useStyles({ isMobile });

  return (
    <React.Fragment>
      <CampfireSwitch>
        <Route path={`${match?.path}/form-builder`} render={() => <FormBuilder />} />

        <Route path={`${match?.path}/responses`} render={() => <FormResponsesScreen />} />

        <Route
          exact
          path={match?.path}
          render={() => (
            <Box className={classes.container}>
              <Box paddingTop='24px' paddingRight={isMobile ? '20px' : '30px'}>
                <FormsMenubar />
              </Box>
              <FormsList />
            </Box>
          )}
        />
      </CampfireSwitch>
    </React.Fragment>
  );
});

export const FormsScreen = () => {
  return <FormsScreenInner />;
};
